<template>
    <main class="container-fluid" style="max-width: 500px">
        <div class="row m-3" v-if="erro">
            <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
                <span v-html="erro"></span>
            </div>
        </div>

        <div class="card my-1 mt-5 px-3 py-3 shadow" style="border-radius: 10px;">
            <div style="text-align: center;">
                <h5 class="header">Agende sua consulta sem sair de casa!</h5>
            </div>
            <div style="text-align: center;">
                <button class="mb-3 mt-2" style="border-radius: 7px; padding: 7px 14px; cursor: pointer;" type="button"
                    @click="agendarConsulta">
                    Agendar consulta
                    <i class="fa-solid fa-calendar-days icon-margin" style="margin-left: 8px; font-size: 20px;"></i>
                </button>
            </div>
        </div>

        <div class="px-3 py-5">
            <div class="row">
                <div id="consultas" class="col selectable" :class="{ 'selected': selectedDiv === 'consultas' }"
                    @click="selectDiv('consultas')"
                    :style="{ border: '1px solid ' + (selectedDiv === 'consultas' ? 'var(--cor-principal)' : 'black') }"
                    style="border: 1px solid black; border-radius: 10px 0 0 10px;">
                    <div style="text-align: center;">
                        <p class="mt-3" :style="{ 'color': selectedDiv === 'consultas' ? 'var(--cor-principal)' : '' }"
                            style="color: #666666; font-weight: bold;">Próximas consultas</p>
                    </div>
                </div>
                <div id="historico" class="col selectable" :class="{ 'selected': selectedDiv === 'historico' }"
                    @click="selectDiv('historico')"
                    :style="{ border: '1px solid ' + (selectedDiv === 'historico' ? 'var(--cor-principal)' : 'black') }"
                    style="border: 1px solid black; border-radius: 0 10px 10px 0;">
                    <div style="text-align: center;">
                        <p class="mt-3" :style="{ 'color': selectedDiv === 'historico' ? 'var(--cor-principal)' : '' }"
                            style="color: #666666; font-weight: bold;">Histórico de atendimentos</p>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="py-2" v-for="agendamento in listaAgendamentosFiltro" :key="agendamento.idAgendamento">
                <div class="px-3">
                    <div class="row">
                        <div id="consultas" class="col-12 selectable"
                            :class="{ 'selected': selectedDiv === 'consultas' }"
                            style="border: 1px solid black; border-radius: 7px 7px 7px 7px;">
                            <div class="mt-3">
                                <div class="row ">
                                    <div class="col-8">
                                        <p style="color: #666666; font-weight: bold;">Consulta
                                            {{ agendamento.nomeEspecialidade }}</p>
                                    </div>
                                    <div class="col-4 d-flex align-items-center justify-content-end ">
                                        <button v-if="selectedDiv === 'consultas'" class="mb-1 mt-1" style="border-radius: 7px; padding: 7px 14px; cursor: pointer;" type="button" 
                                            @click="cancelarAgendamento(agendamento)">
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                                <p class="mt-3" style="color: #666666;">{{ agendamento.agendamentoFormatado }}</p>
                                <div style="text-align: center;">
                                    <div style="text-align: center;">
                                        <div clas="col-xs-12 col-sm-12 col-md-4" style="text-align: center;">
                                            <button v-if="agendamento.status != 'CANCELADO' && agendamento.status != 'REAGENDADO' && agendamento.status != 'EXPIRADO' && agendamento.status != 'FINALIZADO' && agendamento.status != 'AUSENTE'" 
                                                class="mb-2 mt-1 w-100" 
                                                style="border-radius: 7px; 
                                                padding: 7px 14px; 
                                                cursor: pointer;" 
                                                type="button"
                                                @click="abrirUrlNovaTab(agendamento.urlVideoConsulta)">
                                                Acessar consulta
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <b-alert :show="dismissCountDown" dismissible variant="info"
                                            @dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged">
                                            URL copiada para a área de transferência.
                                        </b-alert>
                                    </div>
                                </div>
                                <p style="color: #666666;" v-if="selectedDiv != 'consultas'"><strong
                                        style="color: #666666;">Situação: </strong> {{ agendamento.status }} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="listaAgendamentosFiltro && !listaAgendamentosFiltro.length" class="container-fluid"
            style="margin-top: 125px;">
            <SemAgendamentos></SemAgendamentos>
        </div>

        <Loading v-if="loading"></Loading>
    </main>
</template>
  
  <script>
  import { APITeleMedicinaService } from "@/service/tele-medicina/APITeleMedicinaService";
  const apiTeleMedicinaService = new APITeleMedicinaService();
  import Loading from "@/components/Loading.vue";
  
  import { mapGetters } from 'vuex';
  import SemAgendamentos from './SemAgendamentos.vue';
  
  export default {
    name: "AgendarConsulta",
    components: {
        SemAgendamentos,
        Loading,
    },
    data() {
      return {
        loading: false,
        erro: "",
        selectedDiv: "consultas",
        listaAgendamentos: null,
        statusHistorico: ['CANCELADO', 'REAGENDADO', 'EXPIRADO', 'FINALIZADO', 'AUSENTE'],
        listaAgendamentosFiltro: null,
        dismissSecs: 1,
        dismissCountDown: 0
      };
    },
    computed: {
        ...mapGetters(['getReagendartemp']),
        reagendartemp() {
            return this.getReagendartemp;
        }
    },
    created(){
        this.obterAgendamentos();
        if (this.$store.state.reagendartemp) {
            this.especialidadeSelecionada.value = this.$store.state.reagendartemp.idEspecialidade;
        }
    },
    mounted() {},
    methods: {
        selectDiv(divId) {
            this.selectedDiv = divId;
            if (this.selectedDiv != 'consultas') {
                this.listaAgendamentosFiltro = this.listaAgendamentos.filter(agendamento => {
                    return (this.statusHistorico.includes(agendamento.status));
                });
                this.listaAgendamentosFiltro.reverse();
            } else {
                this.listaAgendamentosFiltro = this.listaAgendamentos.filter(agendamento => {
                    return (!this.statusHistorico.includes(agendamento.status));
                });
            }
        },
        obterAgendamentos(){
            this.loading = true;
            apiTeleMedicinaService.obterAgendamentos().then(response => {
                this.listaAgendamentos = response.map(agendamento => {
                    const dataHoraAgendamento = new Date(agendamento.dataHoraAgendamento);
                    const diaSemana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
                    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
                    let dia = dataHoraAgendamento.getDate();
                    if (dia < 10) {
                        dia = "0" + dia;
                    }
                    const mes = meses[dataHoraAgendamento.getMonth()];
                    const diaSemanaFormatado = diaSemana[dataHoraAgendamento.getDay()];
                    const horas = dataHoraAgendamento.getHours();
                    const minutos = dataHoraAgendamento.getMinutes();
                    const dataFormatada = `${dia}/${mes} - ${diaSemanaFormatado} às ${horas}:${minutos < 10 ? '0' + minutos : minutos} horas`;
                    return {
                        ...agendamento,
                        agendamentoFormatado: dataFormatada
                    };
                });
                this.listaAgendamentos.sort((a, b) => {
                    const dataHoraA = new Date(a.dataHoraAgendamento);
                    const dataHoraB = new Date(b.dataHoraAgendamento);
                    if (dataHoraA.getDate() !== dataHoraB.getDate()) {
                        return dataHoraA - dataHoraB;
                    }
                    return dataHoraA.getHours() - dataHoraB.getHours() || dataHoraA.getMinutes() - dataHoraB.getMinutes();
                });
                this.verificarAgendamentosExpirados();
                this.listaAgendamentosFiltro = this.listaAgendamentos.filter(agendamento => {
                    return (this.selectedDiv === 'consultas' && !this.statusHistorico.includes(agendamento.status));
                });
                this.loading = false;
            }).catch(error => {
                error;
                this.erro = "Erro ao carregar os agendamentos. <br> Por favor, tente novamente mais tarde.";
                this.loading = false;
            });
        },
        verificarAgendamentosExpirados() {
            const dataAtual = new Date();
            const margemDeTempo = 30;

            dataAtual.setMinutes(dataAtual.getMinutes() - margemDeTempo);

            this.listaAgendamentos.forEach(agendamento => {
                const dataAgendamento = new Date(agendamento.dataHoraAgendamento);
                if (dataAgendamento < dataAtual) {
                    if (dataAgendamento.getDate() === dataAtual.getDate()) {
                        if (dataAgendamento.getHours() < dataAtual.getHours() || (dataAgendamento.getHours() === dataAtual.getHours() && dataAgendamento.getMinutes() <= dataAtual.getMinutes())) {
                            agendamento.status = 'EXPIRADO';
                        }
                    } else {
                        agendamento.status = 'EXPIRADO';
                    }
                }
            });
        },
        agendarConsulta(){
            this.$router.push(`/servico/tele-medicina/agendar`);         
            window.scrollTo(0, 0);
        },
        cancelarAgendamento(agendamento){
            this.loading = true;
            apiTeleMedicinaService.cancelarAgendamento(agendamento.idAgendamento).then(response => {
                this.cancelarAgendamentoResponse = response;
                this.$router.push(`/servico/tele-medicina/agendamento-cancelado`);         
                window.scrollTo(0, 0);
            }).catch(error => {
                this.loading = false;
                if (error.response && error.response.data && error.response.data.detail) {
                    const erroDetail = error.response.data.detail;
                    const erroSemPrefixo = erroDetail.replace('Bad Request - ', '');
                    this.erro = erroSemPrefixo;
                } else {
                    this.erro = 'Erro ao cancelar agendamento: Detalhe do erro não encontrado.';
                }
                window.scrollTo(0, 0);
            });
        },
        abrirUrlNovaTab(url) {
            navigator.clipboard.writeText(url)
            .then(() => {
                this.showAlert();
                setTimeout(() => {
                    window.open(url, '_blank');
                }, 1000);
            })
            .catch(err => {
                console.error('Erro ao copiar URL para a área de transferência: ', err);
            });
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        }
    },
    watch: {
    'especialidadeSelecionada.value': function(novoValor, valorAntigo) {
        if (novoValor!== valorAntigo) {
            this.dataSelecionada = null;
            this.listaDias = null;
        }
    }
},
  };
  </script>
  <style scoped lang="scss">
  button {
    background: var(--cor-principal);
    color: var(--cor-texto);
  }
  
  .btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
  }
  
  .a-divider.a-divider-break {
    text-align: center;
    position: relative;
    top: 2px;
    padding-top: 1px;
    margin-bottom: 14px;
    line-height: 0;
  
    &:after {
      content: "";
      width: 100%;
      background-color: transparent;
      display: block;
      height: 1px;
      border-top: 1px solid #e7e7e7;
      position: absolute;
      top: 50%;
      margin-top: -1px;
      z-index: 1;
    }
  
    h5 {
      line-height: 1;
      font-size: 12px;
      color: #767676;
      font-weight: 400;
      z-index: 2;
      position: relative;
      display: inline-block;
      background-color: #fff;
      padding: 0 8px 0 7px;
    }

    .is-invalid {
        border-color: #dc3545;
        padding-right: calc(1.5em + .75rem);
        background-image: url('data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8.046 1.354a.5.5 0 0 0-.892 0L1.137 13.396a.5.5 0 0 0 .446.738h12.834a.5.5 0 0 0 .446-.738L8.046 1.354zm.847 11.793a1 1 0 1 0-1.69 0l-6.25 11a1 1 0 0 0 1.69 1.072l6.25-11z"/></svg>');
        background-repeat: no-repeat;
        background-position: right calc(.375em + .1875rem) center;
        background-size: calc(.75em + .375rem) calc(.75em + .375rem);
    }
    .invalid-feedback {
        width: 100%;
        margin-top: .25rem;
        font-size: 80%;
        color: #dc3545;
    }

    .botoes {
    margin-top: 10px;
    }

    .botoes button {
    margin-right: 10px;
    }

    .custom-heading {
        font-weight: bold;
        color: #500c0c;
    }

    .custom-button:hover {
        background-color: #f0f0f0; 
        border-color: #999999; 
        color: #000000; 
        cursor: pointer; 
    }

    .bordered {
        border: 1px solid black; 
        padding: 10px; 
    }
        
    .header {
        font-weight: bold;
        color: #666666;
        white-space: nowrap;
        font-size: 18px;
        padding: 10px; 
    }

    @media  (max-width: 576px) {
        .header {
            font-size: 16px;
        }
        body{
            color: cyan;
        }
    }
    
    @media screen and (min-width: 993px) and (max-width: 1200px) {
        .header {
            font-size: 20px;
        }
        body{
            color: cyan;
        }
    }

    @media screen and (max-width: 700px) {
        .header {
            font-size: 14px; 
        }
        .btn{
            color: red
        }
    }


    .test {
        color: blue !important;
        background-color: purple !important;
        font-size: 78px !important;
    }

  }
  </style>
  